module.exports = __webpack_public_path__ + "img/banner2.9b5a9454.png";